import React from "react";
import NoScriptBrandLazyLoader from "./NoScriptBrandLazyLoader";
import "./brandGrid.scss";
import { Image } from "@wss/image";

interface Props {
  name: string;
  image: string;
  link: string;
}

const BrandListingItem = ({ name, image, link }: Props) => (
  <a
    id="brand-grid-child"
    href={link}
    title={name}
    className="brand-grid-child border border-solid border-gray-200 rounded-sm h-full box-border xl:h-21 flex flex-col xl:flex-row xl:justify-start xl:items-center self-start hover:shadow-md xl:py-0"
  >
    <Image
      width={1}
      height={1}
      src={image}
      alt={name}
      loading="lazy"
      className="w-16 h-16"
    />
    <div className="xl:pl-4 xl:text-left leading-4">
      <span id="description" className="description text-sm font-semibold">
        {name}
      </span>
    </div>
  </a>
);

export default BrandListingItem;
